<template>
  <!-- 月度分析报告 -->
  <div class="paginations">
    <div class="table-search-box table-search-box-haeder">
      <el-form :inline="true" :model="searchData" class="demo-form-inline">
        <el-form-item label="年份：">
          <el-select size="small" v-model="searchData.name" placeholder="请选择年份" :popper-append-to-body="false">
            <el-option v-for="(item,index) in yearList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报告类型：">
          <el-select size="small" v-model="searchData.type" @change="changeType" placeholder="请选择报告类型" :popper-append-to-body="false" clearable>
            <el-option label="月报报告" value="2"></el-option>
            <el-option label="季度报告" value="4"></el-option>
            <el-option label="专业大数据季度报告" value="8"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="月份：" v-show="searchData.type == 2">
          <el-select size=" small" v-model="searchData.month" @change="changeMonth" placeholder="请选择月份" :popper-append-to-body="false" clearable>
            <el-option v-for="(item,index) in monthlyList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="季度：" v-show="searchData.type == 4">
          <el-select size="small" v-model="searchData.jidu" @change="changeJidu" placeholder="请选择季度" :popper-append-to-body="false" clearable>
            <el-option v-for="(item,index) in quarterList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <div class=" search_button">
            <i class="pointer el-icon-search" @click="search()"></i>
            <i class="pointer el-icon-refresh-left" @click="resetting"></i>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="table_box">
      <el-table :data="tableList" style="width: 100%">
        <el-table-column prop="" type="index" label="序号" align='center'></el-table-column>
        <el-table-column prop="yearStr" label="年份" align='center'></el-table-column>
        <el-table-column prop="monthStr" label="月份" align='center'></el-table-column>
        <!-- 报告类型 -->
        <el-table-column prop="reportType" label="报告类型" align='center'></el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" align='center'>
          <template slot-scope="scope">
            <i class="icona icon-details" title="查看季度分析报告" @click="seeQuarterly(scope.row)"></i>
            <i v-if="scope.row.reportFilePath" class="icona icon-download" title="下载月度分析报告" @click="download(scope.row.reportFilePath)"></i>
            <span v-if="scope.$index != 0 && !scope.row.reportFilePath">——</span>
          </template>
        </el-table-column>
      </el-table>
      <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize" :total="tableLObj.total" :jumpTo="tableLObj.jumpTo" @currentChange="search"></pageNumber>
    </div>
  </div>
</template>

<script>
import pageNumber from '@/components/pageNumber.vue' //分页

export default {
  components: {
    pageNumber
  },
  data() {
    return {
      userType: '',
      monthlyList: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      yearList: [],
      quarterList: ['第一季度', '第二季度', '第三季度', '第四季度'],
      reportList: ['季度报告', '月度报告'],

      // 搜索框 内容

      searchData: {
        name: '',
        type: '',
        monthStr: '',
        month: '',
        jidu: '',
        // 分页数据
        pageDto: {
          pageNum: 1,//当前显示的页面页码数
          pageSize: 10, //一页多少条数据
        },
      },

      tableLObj: {
        total: 0,
        jumpTo: 1,
        list: []
      },
      tableList: [],
    }
  },
  created() {

    this.userType = sessionStorage.getItem('userType')
    // 动态获取 当前时间 年份
    let date = new Date()
    let currentYear = date.getFullYear()
    for (let i = 0; i < 4; i++) {
      this.yearList.push((currentYear - i))
    }

    this.getTableList()
  },

  methods: {
    // 获取列表数据
    getTableList() {
      var data = {
        name: '',
        monthStr: '',
        pageDto: this.searchData.pageDto,
        type: ''
      }
      this.$axios.post(this.$apiurls.report_year_getMonthOrQuarterReportList, data, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.list.length > 0) {
            this.tableList = res.data.list
            for (let i = 0; i < this.tableList.length; i++) {
              this.tableList[i].monthStr = this.tableList[i].monthStr.replace(/0*(\d+)/, '$1')
            }
            this.searchData.pageDto.pageNum = res.data.pageNum
            this.tableLObj.total = res.data.total
          } else {
            this.tableList = []
          }
        }
      });
    },

    // 改变报告类型
    changeType(value) {
      if (value === 2) {
        this.searchData.month = ''
      } else if (value === 4) {
        this.searchData.jidu = ''
      } else if (value === '') {
        this.searchData.month = ''
        this.searchData.jidu = ''
      }
    },

    // 改变报告类型
    changeType() {
      this.searchData.name = this.searchData.name
      this.searchData.type = this.searchData.type
      this.searchData.pageDto = this.searchData.pageDto
      this.searchData.monthStr = ''
      this.searchData.jidu = ''
      this.searchData.month = ''
    },

    // 改变月份
    changeMonth(value) {
      this.searchData.name = this.searchData.name
      this.searchData.monthStr = value
      this.searchData.type = this.searchData.type
      this.searchData.pageDto = this.searchData.pageDto
      this.searchData.jidu = ''
      this.searchData.month = this.searchData.month
    },

    // 改变季度选项
    changeJidu(value) {
      this.searchData.name = this.searchData.name
      this.searchData.monthStr = value
      this.searchData.type = this.searchData.type
      this.searchData.pageDto = this.searchData.pageDto
      this.searchData.jidu = this.searchData.jidu
      this.searchData.month = ''
    },

    search(type) {
      this.searchData.pageDto.pageNum = type ? type : 1
      this.tableLObj.jumpTo = type ? type : 1
      var data = {
        monthStr: this.searchData.monthStr,
        name: this.searchData.name,
        pageDto: this.searchData.pageDto,
        type: this.searchData.type
      }
      this.$axios.post(this.$apiurls.report_year_getMonthOrQuarterReportList, data, {
      }).then((res) => {
        this.tableList = res.data.list
        for (let i = 0; i < this.tableList.length; i++) {
          this.tableList[i].monthStr = this.tableList[i].monthStr.replace(/0*(\d+)/, '$1')
        }
        this.tableLObj.total = res.data.total
        this.tableLObj.tableLObj = 1
      })
    },

    // 重置
    resetting() {
      this.searchData.name = ''
      this.searchData.monthStr = ''
      this.searchData.month = ''
      this.searchData.type = ''
      this.search('')
    },
    // 查看月报分析报告
    seeMonth(row, index) {
      if (index == 0 && this.userType == 1) {
        const news = this.$router.resolve({ name: '/analysisReport', query: { zykName: encodeURIComponent(row.zykname), zykNum: row.zyknum, yearOrMonth: row.yearOrMonth } })
        window.open(`${news.location.name}${news.href}`, '_blank')
      } else {
        window.open(row.reportFilePath)
      }
    },

    // 查看季度分析报告
    seeQuarterly(row) {
      window.open(row.reportFilePath)
    },
    // 下载
    download(url) {
      window.open(`${this.$apiurls.report_yaer_Monthly_downloadReportFile}?filePath=${url}`)
    },
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.table-search-box-haeder {
  height: 40px;
  margin-bottom: 20px;
}

.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>
